<template>
  <div
    v-if="isDisplayed"
    :class="{'md:border-b': !attributes.wishesDisabled}"
    class="border-strong-shadow-color md:mb-4"
  >
    <BaseWarningBox
      v-if="shouldDisplayAcceptedWish"
      class="mb-4 custom-md-width"
    >
      Investissement retenu :
      <span class="font-heavy text-black">
        {{ attributes.currentUserWish.attributes.acceptedAmount | currency({fractionCount: 2}) }}
      </span>
      <template v-if="attributes.currentUserWish.attributes.investmentEntityName">
        <br>
        Entité d'investissement :
        <span class="font-heavy text-black">
          {{ attributes.currentUserWish.attributes.investmentEntityName }}
        </span>
      </template>
    </BaseWarningBox>
    <BaseWarningBox
      v-else-if="attributes.currentUserWish"
      class="mb-4 custom-md-width"
    >
      Vous avez déjà indiqué
      <span class="font-heavy text-black">
        votre souhait d'investissement de
        <BaseCurrencySpan :value="attributes.currentUserWish.attributes.amount" />
      </span>
      pour cette opportunité
    </BaseWarningBox>
    <BaseWarningBox
      v-else-if="attributes.fillingRate >= 100"
      class="mb-4 custom-md-width"
    >
      <span class="font-heavy text-black">Important:</span>
      Le montant total des souhaits exprimés dépasse le montant total
      proposé aux co-investisseurs
      (mais reste inférieur à {{ 100 + attributes.overSubscription }}% de
      celui-ci), vous pouvez donc exprimer un souhait mais sans garantie.
      Les équipes de Kerala feront leurs meilleurs efforts pour qu’il
      soit pris en compte
    </BaseWarningBox>
    <BaseWarningBox
      v-else-if="attributes.declinedAt"
      class="mb-4 custom-md-width"
    >
      <span class="font-heavy text-black">Notice :</span> Vous avez décliné cette opportunité
      le {{ attributes.declinedAt | moment('DD/MM/YYYY à HH:mm') }}.
      Vous pouvez encore changer d'avis et émettre un souhait d'investissement.
    </BaseWarningBox>
    <BaseWarningBox
      v-else-if="attributes.wishesDisabled"
      class="mb-4 custom-md-width"
    >
      <span class="font-heavy text-black">Notice :</span>
      Le recueil des souhaits pour cette opportunité n'a pas encore commencé.
    </BaseWarningBox>
  </div>
</template>

<script>
import BaseWarningBox from '../../components/BaseWarningBox.vue';
import BaseCurrencySpan from '../../components/BaseCurrencySpan.vue';

export default {

  name: 'OpportunityWarningBox',
  components: {
    BaseWarningBox,
    BaseCurrencySpan,
  },
  props: {
    attributes: {
      type: Object,
      required: true,
    },
    withShadow: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    shouldDisplayAcceptedWish() {
      const { attributes } = this;
      return attributes.currentUserWish &&
             attributes.enteredAdministrativePhaseAt &&
             attributes.currentUserWish.attributes.acceptedAmount;
    },
    isDisplayed() {
      return this.attributes.currentUserWish ||
             (this.attributes.fillingRate >= 100)
             || this.attributes.declinedAt
             || this.attributes.wishesDisabled;
    },
  },
};
</script>

<style lang="scss" scoped>
.custom-md-width {
  @media (min-width: 768px) {
    width: calc(100% + 28px);
    margin-left: -14px;
    box-shadow: 0px 1px 2px rgba(91, 46, 15, 0.02), inset 0px -1px 0px rgba(255, 102, 0, 0.04);
  }
}
</style>
